/**
 * DevExtreme (esm/ui/popup/ui.popup.full.js)
 * Version: 24.1.8
 * Build date: Mon Dec 16 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import PopupFull from "../../__internal/ui/popup/m_popup.full";
export default PopupFull;
